import { deleteAccountEpic } from './deleteAccountEpic';

export const epics = [deleteAccountEpic];
